var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","height":"700px"}},[_c('div',{ref:"chart",staticStyle:{"width":"60%"}}),_c('MyTownSwiper',{staticStyle:{"width":"40%"},attrs:{"townInfo":_vm.townInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }